import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Item } from "../../../../../../../../utils/types/generals"
import { DestinationMenuItem } from "../enum/destinationMenu"


export const useMenuDestination = ({ isUnity }: { isUnity:boolean }) => {
    const { t } = useTranslation()
    const [menu, setMenu] = useState<Item[]>([])
    const editItem = { label: t('general.edit'), value: DestinationMenuItem.EDIT }
    const deleteItem = { label: t('general.delete'), value: DestinationMenuItem.DELETE }
    const convertItem = { label: t('general.convert'), value: DestinationMenuItem.CONVERT }
    const optionMenu =  !isUnity ? [editItem, deleteItem,convertItem] : [deleteItem]as Item[]


    useEffect(() => {
        setMenu(optionMenu)
    }, [isUnity])
    return { menu: menu }
}